import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer data-testid="footer-section" className="relative bg-[#101a29] border-t border-white/10 text-white overflow-hidden">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-16 pb-10 sm:pt-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <Link to="/" data-testid="footer-home-link" aria-label="BeaconShield home">
            <Logo size={34} />
          </Link>
          <p className="mt-5 max-w-sm text-sm text-[#b7c2d4] leading-relaxed">
            Find care faster. BeaconShield is currently in internal testing on Google Play and the App Store.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[var(--clinical)]/70">Legal</p>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <Link to="/privacy" data-testid="footer-privacy-link" className="text-slate-200 hover:text-[var(--clinical)] underline-offset-4 hover:underline transition-colors">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms" data-testid="footer-terms-link" className="text-slate-200 hover:text-[var(--clinical)] underline-offset-4 hover:underline transition-colors">
                Terms of Service
              </Link>
            </li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[var(--clinical)]/70">Contact</p>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a href="mailto:beaconshieldapp@gmail.com" data-testid="footer-contact-email" className="text-slate-200 hover:text-[var(--clinical)] underline-offset-4 hover:underline transition-colors">
                beaconshieldapp@gmail.com
              </a>
            </li>
            <li className="text-slate-500">beacon-shield.com</li>
          </ul>
        </div>
      </div>
      <div className="mt-14 border-t border-white/10 pt-6 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-xs text-slate-500">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} BeaconShield, Inc. All rights reserved.</p>
        <p className="font-mono">Not a substitute for emergency services. If this is an emergency, call 911.</p>
      </div>
    </div>
    <p className="pointer-events-none select-none absolute -bottom-6 left-1/2 -translate-x-1/2 font-display text-[22vw] leading-none font-extrabold tracking-tighter text-white/[0.03] whitespace-nowrap">
      BeaconShield
    </p>
  </footer>
);
